export default "__VITE_ASSET__CPQA7Uvm__"